/**
 * Steamer product section — Swiper gallery + vanilla JS helpers.
 * Requires theme Swiper (swiper.min.js).
 */
(function () {
  function getConfig(root) {
    const el =
      root.querySelector('[data-steamer-product-config]') ||
      document.querySelector('[data-steamer-product-config]');
    if (!el) return { showSeeMore: false, customBtn: false };
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return { showSeeMore: false, customBtn: false };
    }
  }

  function copyText(text) {
    if (!text) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).catch(function () {
        fallbackCopy(text);
      });
      return;
    }
    fallbackCopy(text);
  }

  function fallbackCopy(text) {
    const input = document.createElement('input');
    input.setAttribute('readonly', 'readonly');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
  }

  function whenSwiperReady(cb) {
    if (typeof Swiper !== 'undefined') {
      cb();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof Swiper !== 'undefined' || tries > 50) {
        clearInterval(timer);
        if (typeof Swiper !== 'undefined') cb();
      }
    }, 100);
  }

  function initGallery(root) {
    whenSwiperReady(function () {
      root.querySelectorAll('.grid__item').forEach(function (galleryItem) {
        var mainEl = galleryItem.querySelector('.steamer-product-main.swiper');
        var thumbsEl = galleryItem.querySelector('.steamer-product-thumbs.swiper');
        var wrap = galleryItem.querySelector('.product-thumbnails-wrap');
        if (!mainEl || !thumbsEl || mainEl.dataset.steamerGalleryInit === '1') return;
        mainEl.dataset.steamerGalleryInit = '1';

        var prevEl = wrap && wrap.querySelector('.product-thumb-nav--prev');
        var nextEl = wrap && wrap.querySelector('.product-thumb-nav--next');

        var thumbsSwiper = new Swiper(thumbsEl, {
          slidesPerView: 'auto',
          spaceBetween: 6,
          freeMode: true,
          watchOverflow: true,
        });

        var mainSwiper = new Swiper(mainEl, {
          slidesPerView: 1,
          allowTouchMove: true,
          watchOverflow: true,
        });

        // Expose the swiper instances so applyColorFilter() can slideTo the first
        // visible slide when a swatch filters the gallery.
        galleryItem.steamerGalleryMain = mainSwiper;
        galleryItem.steamerGalleryThumbs = thumbsSwiper;

        function setActiveThumb(index) {
          thumbsEl.querySelectorAll('.product-thumbnails__item').forEach(function (item, i) {
            item.classList.toggle('product-thumbnails__item--active', i === index);
          });
        }

        function goTo(index) {
          var total = mainSwiper.slides.length;
          if (!total) return;
          if (index < 0) index = total - 1;
          if (index >= total) index = 0;
          mainSwiper.slideTo(index);
          thumbsSwiper.slideTo(index);
          setActiveThumb(index);
        }

        mainSwiper.on('slideChange', function () {
          var index = mainSwiper.activeIndex;
          thumbsSwiper.slideTo(index);
          setActiveThumb(index);
        });

        thumbsEl.querySelectorAll('[data-product-single-thumbnail]').forEach(function (thumb, index) {
          thumb.addEventListener('click', function (e) {
            e.preventDefault();
            goTo(index);
          });
        });

        if (prevEl) {
          prevEl.addEventListener('click', function (e) {
            e.preventDefault();
            goTo(mainSwiper.activeIndex - 1);
          });
        }

        if (nextEl) {
          nextEl.addEventListener('click', function (e) {
            e.preventDefault();
            goTo(mainSwiper.activeIndex + 1);
          });
        }

        setActiveThumb(mainSwiper.activeIndex);
      });
    });
  }

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var id = el.dataset.sectionId || el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    if (typeof drawer.showDialog === 'function') {
      drawer.showDialog();
    }
  }

  function dispatchCartUpdate(sections, variantId, itemCount, cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart || {},
          sourceId: 'steamer-product',
          data: {
            source: 'steamer-product',
            variantId: variantId ? String(variantId) : undefined,
            itemCount: Number(itemCount) || 0,
            sections: sections || {},
          },
        },
      })
    );
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    btn.disabled = !!loading;
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
    btn.classList.toggle('is-loading', !!loading);
  }

  async function addFormToCart(form) {
    var formData = new FormData(form);
    if (!formData.get('quantity')) formData.set('quantity', '1');

    var sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      formData.set('sections', sectionIds.join(','));
      formData.set('sections_url', window.location.pathname);
    }

    var res = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    });

    var data = await res.json();
    if (data.status && (data.description || data.message)) {
      throw new Error(data.description || data.message || 'Add to cart failed');
    }

    var cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    var cart = await cartRes.json();

    dispatchCartUpdate(data.sections, formData.get('id'), cart.item_count, cart);
    openCartDrawer();
    return data;
  }

  function initAjaxAddToCart(root) {
    root.querySelectorAll('form.product-form').forEach(function (form) {
      if (form.dataset.steamerAjaxBound === '1') return;
      form.dataset.steamerAjaxBound = '1';

      form.addEventListener('submit', function (event) {
        var submitter = event.submitter;
        if (
          submitter &&
          (submitter.closest('shopify-accelerated-checkout') ||
            submitter.closest('.shopify-payment-button') ||
            submitter.getAttribute('name') === 'checkout')
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        var atcButton =
          (submitter && submitter.matches('[data-add-to-cart], button[name="add"]') && submitter) ||
          form.querySelector('[data-add-to-cart], button[type="submit"][name="add"]');
        setButtonLoading(atcButton, true);

        addFormToCart(form)
          .catch(function (err) {
            console.error(err);
            window.alert(err.message || 'Could not add to cart');
          })
          .finally(function () {
            setButtonLoading(atcButton, false);
          });
      });
    });
  }

  function handleChangeProductSelect(target) {
    const wrapper = target.closest('.product-form__wrapper');
    if (!wrapper) return;

    const allSelects = wrapper.querySelectorAll('select[data-single-option-selector]');
    const allSelectedValues = Array.from(allSelects).map(function (v) {
      return v.value;
    });

    // Update the form's select[name="id"][data-product-select] so the submitted
    // (Add to Cart) carries the chosen variant instead of the default.
    const productSelecters = wrapper.querySelectorAll('select[data-product-select]');
    if (!productSelecters.length) return;

    productSelecters.forEach(function (productSelecter) {
      const options = Array.from(productSelecter.options);
      const match = options.find(function (opt) {
        if (opt.disabled) return false;
        const str = opt.label || opt.textContent || '';
        return allSelectedValues.every(function (val) {
          return str.indexOf(val) !== -1;
        });
      });
      if (match) match.selected = true;
    });
  }

  // Fake variant: clicking a colour swatch filters the gallery to that colour.
  // Each slide carries a colour-{{handle}} class derived from media.alt's last
  // "|" segment (handle of the colour option value). Slides whose link/thumb
  // doesn't match the clicked handle get hidden; the gallery then slides to the
  // first visible one. If nothing matches (bad alt data) we show all slides.
  // Clicking a colour swatch jumps the main gallery to that colour's image.
  // Slides are tagged color-{variantColorHandle} (from real variant media).
  // We slideTo the first matching slide — no slide-hiding, so Swiper stays reliable.
  function applyColorFilter(root, handle) {
    var handle2 = handle || '';
    if (!handle2) return;
    root.querySelectorAll('.grid__item').forEach(function (galleryItem) {
      var mainEl = galleryItem.querySelector('.steamer-product-main.swiper');
      var thumbsEl = galleryItem.querySelector('.steamer-product-thumbs.swiper');
      if (!mainEl) return;

      var target = -1;
      mainEl.querySelectorAll('.swiper-slide').forEach(function (slide, i) {
        if (target !== -1) return;
        var link = slide.querySelector('a.product-image__link, .product-image__no-link');
        if (link && link.classList.contains('color-' + handle2)) target = i;
      });

      if (target === -1) {
        var found = [];
        mainEl.querySelectorAll('.swiper-slide .product-image__link').forEach(function (l) {
          Array.from(l.classList).forEach(function (c) {
            if (c.indexOf('color-') === 0 && found.indexOf(c) === -1) found.push(c);
          });
        });
        // eslint-disable-next-line no-console
        console.warn(
          '[steamer-product] colour filter "' + handle2 + '" matched 0 slides. ' +
          'Found colour tags on main slides: [' + found.join(', ') + ']. ' +
          'Check that each product image alt ends with "|<ColorValue>" (e.g. "...|Mellow Yellow"), ' +
          'matching the colour swatch value.'
        );
        return;
      }

      if (galleryItem.steamerGalleryMain) {
        galleryItem.steamerGalleryMain.slideTo(target, 0);
      }
      if (galleryItem.steamerGalleryThumbs) {
        galleryItem.steamerGalleryThumbs.slideTo(target, 0);
      }
      if (thumbsEl) {
        thumbsEl.querySelectorAll('.product-thumbnails__item').forEach(function (item, i) {
          item.classList.toggle('product-thumbnails__item--active', i === target);
        });
      }
    });
  }

  function initVariantSelectors(root) {
    root.querySelectorAll('select[data-single-option-selector]').forEach(function (select) {
      select.addEventListener('change', function (e) {
        handleChangeProductSelect(e.target);
      });
    });

    root.querySelectorAll('.clickyboxes[data-single-option-selector] > li').forEach(function (li) {
      li.addEventListener('click', function (e) {
        const selectorWrapper = li.closest('.selector-wrapper');
        if (!selectorWrapper) return;

        const variantSelector = selectorWrapper.querySelector(
          'select[data-single-option-selector]'
        );
        const link = li.querySelector('a');
        const selectedValue = link && link.getAttribute('data-value');

        if (variantSelector && selectedValue != null) {
          const options = variantSelector.querySelectorAll('option');
          let matched = false;
          options.forEach(function (opt) {
            if (opt.value === selectedValue) {
              opt.selected = true;
              matched = true;
            }
          });
          if (!matched) {
            const index = Array.from(li.parentElement.children).indexOf(li);
            if (options[index]) options[index].selected = true;
          }
          variantSelector.dispatchEvent(new Event('change', { bubbles: true }));
        }

        selectorWrapper
          .querySelectorAll('.clickyboxes[data-single-option-selector] > li > a')
          .forEach(function (a) {
            a.classList.remove('active');
          });

        const title = selectorWrapper.querySelector('label > .variant-option-title');
        if (link) {
          link.classList.add('active');
          if (title) title.textContent = link.getAttribute('data-value') || '';
        }

        handleChangeProductSelect(li);

        var optClass =
          link &&
          Array.from(link.classList).find(function (c) {
            return c.indexOf('opt--') === 0;
          });
        applyColorFilter(root, optClass ? optClass.slice('opt--'.length) : '');
      });
    });
  }

  function initDiscountAndCopy(root) {
    const optionLists = root.querySelectorAll('.option--color .clickyboxes li a');
    const discountLists = root.querySelectorAll('.product_variant_discount');
    const codeLists = root.querySelectorAll('.product-discount-full__code-text h5 span');
    const codeBlocks = root.querySelectorAll('.product_variant_code');

    function discountChange() {
      if (!discountLists.length) return;

      optionLists.forEach(function (option) {
        if (!option.classList.contains('active')) return;
        const value = option.getAttribute('data-value');

        discountLists.forEach(function (discount, num) {
          const variantTitle = discount.getAttribute('data-value');
          const code = codeBlocks[num];
          if (variantTitle === value) {
            discount.classList.remove('hide');
            if (code) code.classList.remove('hide');
          } else {
            discount.classList.add('hide');
            if (code) code.classList.add('hide');
          }
        });
      });
    }

    discountChange();

    optionLists.forEach(function (option) {
      option.addEventListener('click', function () {
        setTimeout(discountChange, 0);
      });
    });

    root.querySelectorAll('.product-discount-full__btn-copy').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.currentTarget.dataset.success = 'true';
        let text = '';

        codeLists.forEach(function (code) {
          if (!code.classList.contains('hide')) {
            text = code.textContent || '';
          }
        });

        if (!text) {
          const fallback = root.querySelector(
            '.product-discount-full__code-text > h5 > span'
          );
          text = fallback ? fallback.textContent || '' : '';
        }

        copyText(text.trim());

        setTimeout(function () {
          btn.dataset.success = 'false';
        }, 2000);
      });
    });
  }

  function initSeeMore(root, enabled) {
    if (!enabled) return;

    const desc = root.querySelector('.product_desc');
    const inner = desc && desc.querySelector('div');
    const moreBtn = root.querySelector('.product_moredesc');
    if (!desc || !inner || !moreBtn) return;

    function applyClamp() {
      if (window.innerWidth <= 1000) {
        desc.style.height = 'auto';
        moreBtn.style.display = 'none';
        return;
      }
      const lineHeight = parseInt(getComputedStyle(inner).lineHeight, 10) || 24;
      const max = lineHeight * 3;
      desc.style.height = max + 'px';
      moreBtn.style.display = inner.scrollHeight > max ? '' : 'none';
    }

    applyClamp();
    window.addEventListener('resize', applyClamp);
    moreBtn.addEventListener('click', function () {
      desc.style.height = 'auto';
      moreBtn.style.display = 'none';
    });
  }

  function initCustomPayment(root, enabled) {
    if (!enabled) return;
    root.querySelectorAll('.product-btn_box .custom_payment_btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const payBtn = btn.parentElement.querySelector(
          '.shopify-payment-button .shopify-payment-button__button'
        );
        if (payBtn) payBtn.click();
      });
    });
  }

  function init(root) {
    if (root.dataset.steamerInit === '1') return;
    root.dataset.steamerInit = '1';

    const config = getConfig(root);
    initGallery(root);
    initVariantSelectors(root);
    initDiscountAndCopy(root);
    initSeeMore(root, !!config.showSeeMore);
    initCustomPayment(root, !!config.customBtn);
    initAjaxAddToCart(root);

    root.querySelectorAll('.product-price_add-box .sale_tips--has-now-price').forEach(function (tips) {
      const box = tips.closest('.product-price_add-box');
      if (box) box.classList.add('product-price_add-box--has-now-price');

      const price = tips.parentElement && tips.parentElement.querySelector('.product-price, product-price .price');
      if (price) price.classList.add('price-line');
    });
  }

  function boot() {
    document
      .querySelectorAll('.section-product-template [data-section-type="product"]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-section-type="product"]');
    if (root && event.target.classList.contains('section-product-template')) {
      init(root);
    }
  });
})();
